import React, { useState, useEffect } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import LanguageSelector from './LanguageSelector';
import '../styles/Header.css';

const Header: React.FC = () => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const [isProfileDropdownOpen, setIsProfileDropdownOpen] = useState(false);
  const location = useLocation();
  const navigate = useNavigate();
  const { t } = useTranslation();

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 0);
    };

    // 检查用户是否已登录
    const token = localStorage.getItem('token');
    setIsLoggedIn(!!token);

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const handleLogout = () => {
    localStorage.removeItem('token');
    localStorage.removeItem('user_id');
    setIsLoggedIn(false);
    navigate('/login');
  };

  const handlePricingClick = (e: React.MouseEvent) => {
    e.preventDefault();
    console.log('价格按钮被点击');
    console.log('当前路径:', location.pathname);
    
    if (location.pathname !== '/') {
      console.log('不在首页，准备导航到首页');
      // 先导航到首页，并添加hash
      navigate('/#pricing');
      console.log('已触发导航到: /#pricing');
    } else {
      console.log('已在首页，准备滚动');
      // 如果已经在首页，直接滚动
      const pricingSection = document.getElementById('pricing');
      console.log('找到pricing部分:', !!pricingSection);
      if (pricingSection) {
        pricingSection.scrollIntoView({ behavior: 'smooth' });
        console.log('已执行滚动');
      }
    }
  };

  // 如果是登录页面，不显示 header
  if (location.pathname === '/login') {
    return null;
  }

  return (
    <header className={`header ${isScrolled ? 'scrolled' : ''}`}>
      <div className="header-container">
        <div className="logo">
          <Link to="/">
            <span className="logo-text">Ark App Builder</span>
          </Link>
        </div>
        
        <nav className="nav-menu">
          <Link to="/" className="nav-item">{t('nav.home')}</Link>
          <Link to="/apps" className="nav-item">{t('nav.apps')}</Link>
          <Link to="/templates" className="nav-item">{t('nav.templates')}</Link>
          <Link to="/docs" className="nav-item">{t('nav.docs')}</Link>
          <a href="#pricing" className="nav-item" onClick={handlePricingClick}>{t('nav.pricing')}</a>
        </nav>

        <div className="header-actions">
          <LanguageSelector />
          {isLoggedIn ? (
            <div className="profile-dropdown">
              <button 
                className="login-button"
                onClick={() => setIsProfileDropdownOpen(!isProfileDropdownOpen)}
              >
                {t('auth.profile')}
              </button>
              {isProfileDropdownOpen && (
                <div className="dropdown-menu">
                  <Link to="/profile" className="dropdown-item">{t('auth.profile')}</Link>
                  <Link to="/model-config" className="dropdown-item">模型配置</Link>
                  <button onClick={handleLogout} className="dropdown-item">{t('auth.logout')}</button>
                </div>
              )}
            </div>
          ) : (
            <>
              <Link to="/login" className="login-button">{t('auth.login')}</Link>
              <Link to="/register" className="signup-button">{t('auth.signup')}</Link>
            </>
          )}
        </div>
      </div>
    </header>
  );
};

export default Header; 